import getQpVersion from '../../utils/getQpVersion';
import { InputTelephoneNumStoreModel } from '.';
import {qav} from "../../utils/qav";

interface MsgModel {
    bizType?: string;
    page?: string;
    operType?: string;
    module?: string;
    title?: string;
}

class QAV {
    public rootStore: InputTelephoneNumStoreModel;
    public msg: MsgModel;
    public qpVersion: number;
    public constructor(rootStore: InputTelephoneNumStoreModel) {
        this.rootStore = rootStore;
        this.msg = {
            bizType: 'pp',
            page: 'queryorderbyphone',
            operType: 'show'
        };
        this.getQp();
    }

    public async getQp() {
        this.qpVersion = (await getQpVersion()) as number;
    }

    public send(msg: MsgModel) {
        if (!msg.module) {
            console.warn('请输入 module');
            return
        }
        const config = {
            ...this.msg,
            operTime: Date.now(),
            qpVer: this.qpVersion,
            ...msg
        };
        // console.log(config);
        qav(config);
    }

    public toast(title: string) {
        this.send({
            title,
            module: 'toast',
            operType: 'show'
        });
    }
}

export default QAV;
